import classNames from 'classnames';
import React, { MouseEventHandler } from 'react';

const ReactButton = ({ onClick, className, showAlways }: { className?: string; onClick: MouseEventHandler<SVGSVGElement>; showAlways?: boolean }) => {
  return (
    <div
      className={classNames(
        'w-10 h-[26px] cursor-pointer flex items-center justify-center bg-gray1 shadow rounded-lg',
        showAlways ? '' : 'invisible group-hover:visible group active:scale-95',
        className
      )}
      onClick={onClick as any}
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='18'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      >
        <path className='active:stroke-action' stroke='#525A68' d='M22 11v1a10 10 0 1 1-9-10' />
        <path className='active:stroke-action' stroke='#525A68' d='M8 14s1.5 2 4 2 4-2 4-2' />
        <line className='active:stroke-action' stroke='#525A68' x1='9' x2='9.01' y1='9' y2='9' />
        <line stroke='#525A68' x1='15' x2='15.01' y1='9' y2='9' />
        <path className='active:stroke-action' stroke='#525A68' d='M16 5h6' />
        <path className='active:stroke-action' stroke='#525A68' d='M19 2v6' />
      </svg>
    </div>
  );
};

export default ReactButton;
